import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { TextContext } from '@/utils/contexts/TextContext';
import { ModalContext } from '@/utils/contexts/ModalContext';

import styles from '@/views/pages/Letter/elements/LetterFinishSimplificationBar.module.scss';

const LetterFinishSimplificationBar = () => {
	const { dict } = useSelector((state) => state.app);
	const { contextState } = useContext(TextContext);
	const { showModal } = useContext(ModalContext);

	return (
		<div className={ styles['finish-simplification-bar'] }>
			<span><span className={ styles['text-bold'] }>{dict.letter.finishSimplificationBar.text1}</span>{dict.letter.finishSimplificationBar.text2}</span>
			<div
				className='button__blue'
				onClick={ () => {
					showModal({
						componentName: 'ModalImportFinalVersion',
						additionalInfo: {
							id: contextState.letterData.id,
							templateId: contextState.letterData.letterTemplateId,
						},
					});
				} }
			>
				{dict.letter.finishSimplificationBar.button}
			</div>
		</div>
	);
};
export default React.memo(LetterFinishSimplificationBar);